
// @ts-nocheck
import { YandexPayController } from '~/lib/yandexPay';
import { YaPaySdk } from '~/types/yaPay';

declare var YaPay: YaPaySdk.YaPay | undefined;

export default {
    props: {
        price: {
            type: Number,
            required: true
        }
    },
    async mounted() {
        await YandexPayController.getInstance();
        if (YaPay) {
            await YaPay.mountBadge(
                this.$el as HTMLElement,
                {
                    type: 'bnpl',
                    amount: this.price.toFixed(2),
                    size: 'm',
                    variant: 'detailed',
                    color: 'primary',
                    merchantId: '8480cbf0-58df-4fe3-8b17-9cb8b9f9cb26',
                }
            );
        }
    },
    beforeDestroy() {

    }
};

